import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function TourFilledIcon({ width, height, viewBox, style, className }: IIcon) {
    return (
        <Icon
            width={width}
            height={height}
            viewBox={viewBox ?? '0 0 24 24'}
            style={style}
            className={className}
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.2 1.44043H9.12004C8.85603 1.44043 8.64003 1.65643 8.64003 1.92043V6.48045H4.39682C4.19858 6.48045 3.95282 6.52557 3.71641 6.59877C3.47977 6.67125 3.25225 6.77181 3.09145 6.88245L0.241441 8.83846C0.0804003 8.94886 0 9.09478 0 9.24046C0 9.38614 0.0804003 9.53134 0.241441 9.64222L3.09145 11.5985C3.25249 11.7089 3.47977 11.8094 3.71641 11.8824C3.95306 11.9553 4.19882 12.0005 4.39682 12.0005H8.64003V22.5605C8.64003 22.8245 8.85603 23.0405 9.12004 23.0405H10.2C10.464 23.0405 10.68 22.8245 10.68 22.5605V1.92043C10.68 1.65643 10.464 1.44043 10.2 1.44043ZM23.7584 6.43899L20.9084 4.48251C20.7474 4.37187 20.5201 4.27154 20.2834 4.19834C20.0468 4.12562 19.801 4.0805 19.603 4.0805H11.4L12.3608 9.60053H19.603C19.801 9.60053 20.047 9.5554 20.2834 9.48244C20.5201 9.40972 20.7476 9.30916 20.9084 9.19876L23.7584 7.24228C23.9195 7.13164 24.0001 6.98644 24.0001 6.84051C24.0001 6.69483 23.9195 6.54939 23.7584 6.43899Z"
                fill="currentColor"
            />
        </Icon>
    );
}
